//import Moment from "moment";

const getCount = (state) => {
	return state.ordensServico.length;
}

const ultimaAtualizacaoListaOrdemServico = (state) => {
	if (state.ultimaAtualizacaoListaOrdemServico == null) {
		return true;
	}
	else if(!state.ordensServico)
	{
		return true;
	}
	else {
		const d = new Date();
		let hour = d.getHours();
		return (
			state.ordensServico.length == 0 ||
			hour - state.ultimaAtualizacaoListaOrdemServico.getHours() > 0
		);
	}
}

export default {
	getCount,
	ultimaAtualizacaoListaOrdemServico
}